import { spawn, call, put, takeLatest } from 'redux-saga/effects';
import { createAction } from '@reduxjs/toolkit';
import { lateActions } from '../../../application/actions/late';

import api from '../../api/index';

const apiRequest = api(process.env.REACT_APP_HOST);


// SESION
export function* findLate(e) {
    console.log("findLate")
    yield put(lateActions.lateConexion({conexion:true}));
    try {
        const  params  = e.payload;
        const optionalsHeaders = {
            'Content-Type': 'application/json; charset=utf-8',
            'Access-Control-Allow-Origin': '*'
        }
        const url = `late/late.php?`
        const response = yield call(
            apiRequest.post,
            url,
            params,
            optionalsHeaders
        );

        const { data, nota, result } = response;;
        yield put(lateActions.lateCreate({ data, nota, result }));
    } catch (err) {
        yield put(lateActions.lateConexion({conexion:false}));
        yield put(lateActions.lateError({error:err.message}));
    } finally {
    }
}

export function* watchFetchSesion() {
    yield takeLatest(LateActionsSaga.findLateService.type, findLate);
}

export default function* rootSaga() {
    yield spawn(watchFetchSesion);
}


const findLateService = createAction('lateSaga/findLateService');

export const LateActionsSaga = {
    findLateService,
};
